
import { BarChart3, Compass, LineChart, PieChart, Users } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { BenefitCard } from "@/components/ui/benefit-card";
import { FeaturePageLayout } from "@/components/layout/FeaturePageLayout";

const MarketAnalysisOpportunities = () => {
  const { t } = useTranslation("platform");
  
  return (
    <FeaturePageLayout 
      title={t("marketAnalysisOpportunities.title")} 
      subtitle={t("marketAnalysisOpportunities.subtitle")} 
      description={t("marketAnalysisOpportunities.summaryDescription")} 
      icon={<BarChart3 className="h-6 w-6 text-white" />} 
      bgColor="bg-gradient-to-r from-primary/90 via-purple-600/90 to-primary/90"
    >
      <div className="container mx-auto px-4 py-8">
        {/* Hero Section */}
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold mb-3">{t("marketAnalysisOpportunities.pageTitle")}</h2>
          <p className="text-gray-600 max-w-3xl mx-auto">
            {t("marketAnalysisOpportunities.summaryDescription")}
          </p>
        </div>

        {/* Combined Market Analysis & Opportunities Section */}
        <div className="mb-12">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {/* Market Analysis Panel */}
            <div className="bg-gray-50 p-5 rounded-lg">
              <h2 className="text-2xl font-bold mb-3">{t("marketAnalysisOpportunities.marketAnalysis.title")}</h2>
              <p className="text-gray-600 mb-3">
                {t("marketAnalysisOpportunities.marketAnalysis.description")}
              </p>
              
              <Link to="/competitor-analysis">
                
              </Link>
            </div>
            
            {/* Opportunity Finder Panel */}
            <div className="bg-gray-50 p-5 rounded-lg">
              <h2 className="text-2xl font-bold mb-3">{t("marketAnalysisOpportunities.opportunities.title")}</h2>
              <p className="text-gray-600 mb-3">
                {t("marketAnalysisOpportunities.opportunities.description")}
              </p>
              
              <Link to="/opportunity-finder">
                
              </Link>
            </div>
          </div>
        </div>
      </div>
    </FeaturePageLayout>
  );
};

export default MarketAnalysisOpportunities;
